import React, {useCallback, useMemo, useState} from 'react';
import MemoCoinImage from "../CoinImage";
import argos from "../../assets/argos.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck, faCircleXmark, faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import {IActivityCoins, IIdStatus, IWallet} from "../../types/type";
import EachCoinArticle from "../EachCoinArticle";
import {useTranslation} from "react-i18next";

interface IWalletContents {
    activityCoin: IActivityCoins | null
    liveFormResult: IIdStatus | null
    step: number
    wallet?: IWallet[]
}


const WalletContentsWrapper: React.FC<IWalletContents> =
    ({
         liveFormResult,
         activityCoin,
         step,
         wallet
     }) => {


        const {t} = useTranslation();

        const [showBlockChainList , setShowBlockChainList] = useState<boolean>(false);

        const activityCoinWithAtLeastOne = useMemo(() => {
            if (activityCoin) {
                const res = Object.values(activityCoin).find(value => value);
                if (res) {
                    return true
                }
            }
            return false
        }, [activityCoin])



        const argosValidationIcon = useCallback((): React.ReactNode => {
            if (liveFormResult === IIdStatus.notApproved || liveFormResult === IIdStatus.rejected) {
                return <FontAwesomeIcon icon={faCircleXmark} className={'ml-1.5 text-rose-600'}/>
            }
            if (liveFormResult === IIdStatus.pending) {
                return <FontAwesomeIcon icon={faExclamationCircle} className={'ml-1.5 text-purple-500'}/>
            }
            if (liveFormResult === IIdStatus.approved) {
                return <FontAwesomeIcon icon={faCircleCheck} className={'ml-1.5 text-lime-600'}/>
            }
            return <FontAwesomeIcon icon={faCircleXmark} className={'ml-1.5 text-rose-600'}/>
        }, [liveFormResult])


        const argosValidationText = useCallback((): React.ReactNode => {
            const commonTextClass = 'mt-1.5 text-sm '

            if (liveFormResult === IIdStatus.pending) {
                return <p className={`${commonTextClass} text-purple-600`}>{t('kyc-pending-1')}<br/>{t('kyc-pending-2')}</p>
            }
            if (liveFormResult === IIdStatus.rejected) {
                return <p className={`${commonTextClass} text-rose-600`}>{t('kyc-reject-1')}<br/>{t('kyc-reject-2')}</p>
            }

            if (liveFormResult === IIdStatus.notApproved) {
                return <p className={`${commonTextClass} text-rose-600`}>{t('need-to-generate-ARGOS-ID')}</p>
            }
            return
        }, [liveFormResult])




        return (
            <>
                    {/*user stauts가 closed이면 */}

                    {
                        step === 0 &&
                        <article className={'flex flex-col text-sm my-3'}>
                            <h3 className={'text-sm font-bold'}>{t('identity-information')}</h3>
                            <div className={'flex items-center mt-1.5'}>
                                <MemoCoinImage bgColor={''} coinName={'Argos Logo'} logoSrc={argos}/>
                                <span className={'font-bold ml-1.5'}>ARGOS ID</span>
                                {
                                    argosValidationIcon()
                                }
                            </div>
                            {
                                argosValidationText()
                            }
                        </article>
                    }



                {
                    activityCoinWithAtLeastOne &&
                    <article className={'flex flex-col my-1.5'}>
                        {
                            step === 0 ?
                                <h3 className={'my-1.5 text-sm font-bold text-sm'}>{t('block-chain-network-0')}</h3>
                                :
                                <div className={'text-xxxs flex justify-between items-center'}>
                                    <h3 className={'my-1.5 font-bold'}>{t('block-chain-network-1')}</h3>
                                    <div className={`flex items-center`}>
                                        <input id={'hide-chain-list'} type={'checkbox'} checked={showBlockChainList} onChange={() => setShowBlockChainList(prev => !prev)}/>
                                        <label htmlFor={'hide-chain-list'} className={'mx-1 cursor-pointer'}>{t('hide-verified')}</label>
                                    </div>
                                </div>
                        }


                        <ul className={`text-sm ${step === 2 && ' flex gap-3'}`}>
                            {
                                activityCoin && (Object.keys(activityCoin) as (keyof typeof activityCoin)[]).map((coinKey) =>
                                    <EachCoinArticle key={coinKey}
                                                     activityCoin={activityCoin}
                                                     coinKey={coinKey}
                                                     step={step}
                                                     wallet={wallet}
                                                     showBlockChainList={showBlockChainList}
                                    />
                                )
                            }
                        </ul>

                    </article>
                }

            </>

        )
    }


export default WalletContentsWrapper;